<template>
  <!-- class="table-page-search-wrapper" -->
  <div class="scheduling-order-form-container">
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :form="schedulingOrderData">
      <a-form-item label="公司主体" >
        <!-- <a-input disabled v-model="schedulingOrderData.vendorCode" /> -->
        <global-select
          :disabled="isCantEdit"
          :dropdown-match-select-width="false"
          v-model="schedulingOrderData.vendorCode"
          selectType="selectDropDownRefresh"
          requestApi="/scp/scpProductionScheduling/findSupplierByItem"
          :setParams="{ itemId: schedulingOrderData.itemId }"
          :selectItem="{ value: 'realValue', label: 'label' }"
          @change="handleVendorCodeChange"
        />
      </a-form-item>
      <a-form-item label="库存组织">
        <a-select v-model="schedulingOrderData.orgNo" option-label-prop="label" :disabled="isCantEdit" :allowClear="true">
          <a-select-option v-for="(item) in orgNoList" :key="item.orgNo" :value="item.orgNo" :label="item.orgName">
            {{ item.orgName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="工单号">
        <a-input disabled v-model="schedulingOrderData.wipEntityName" />
      </a-form-item>
      <a-form-item label="计划单号">
        <a-input disabled :value="computedOrderNo" />
      </a-form-item>
      <a-form-item label="物料编码">
        <a-input disabled v-model="schedulingOrderData.itemCode" />
      </a-form-item>
      <a-form-item label="物料名称">
        <a-input disabled v-model="schedulingOrderData.itemName" />
      </a-form-item>
      <a-form-item label="需求数量">
        <a-input disabled v-model="schedulingOrderData.orderQuantity" />
      </a-form-item>
      <a-form-item label="交货时间">
        <a-date-picker show-time disabled v-model="schedulingOrderData.deliveryDate" />
      </a-form-item>
      <a-form-item label="车间">
        <a-input disabled v-model="schedulingOrderData.workCode" />
      </a-form-item>
      <a-form-item label="产线">
        <!-- <a-input :disabled="isCantEdit" v-model="schedulingOrderData.lineCode" /> -->
        <global-select
          ref="refLineCodeSelector"
          :disabled="isCantEdit"
          :dropdown-match-select-width="false"
          v-model="schedulingOrderData.lineCode"
          selectType="select"
          requestApi="/scp/scpProductionScheduling/findLineCodeBySupplier"
          :setParams="{ vendorCode: schedulingOrderData.vendorCode }"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </a-form-item>
      <a-form-item label="开始时间">
        <a-date-picker
          show-time
          :disabled="isCantEdit"
          v-model="schedulingOrderData.startDate"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-item>
      <a-form-item label="结束时间">
        <a-date-picker
          show-time
          :disabled="isCantEdit"
          v-model="schedulingOrderData.completionDate"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-item>
      <a-form-item label="备注">
        <a-input :disabled="isCantEdit" v-model="schedulingOrderData.remarks" />
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { saveWork, getFindOrgBySupplierCode } from "@/api/scp/productionScheduling/schedulingWorkbench.js"

export default {
  name: 'SchedulingOrderForm',
  components: {
  },
  props: {
    schedulingOrderData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isCantEdit () {
      return !!(this.schedulingOrderData.wipEntityName && this.schedulingOrderData.wipEntityName.trim() !== '')
    },
    computedOrderNo () {
      if (this.schedulingOrderData.orderNo && this.schedulingOrderData.orderNo.indexOf('-L') !== -1) {
        return this.schedulingOrderData.orderNo.split('-L')[0]
      } else {
        return this.schedulingOrderData.orderNo
      }
    }
  },
  data () {
    // 查询参数
    return {
      orgNoList: [], // 库存组织数据
      // 表格字段
      form: { name: '' }
    }
  },
  methods: {
    submit () {
      if (!this.schedulingOrderData.id || !this.schedulingOrderData.vendorCode) {
        return;
      }
      if (!this.schedulingOrderData.lineCode) {
        this.$message.error('请选择产线')
        return;
      }
      saveWork(this.schedulingOrderData).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$message.success('保存完毕')
          this.$emit('refresh-page')
        }
      })
    },
    // 获取库存组织数据
    findOrg(type) {
      this.orgNoList = []
      if (this.schedulingOrderData?.vendorCode) {
        getFindOrgBySupplierCode({ supplierCode: this.schedulingOrderData.vendorCode }).then(res => {
          if (res?.code === 200 && res?.data?.length > 0) {
            this.orgNoList = res.data
            // 当库存组织为空，或者手动修改了公司主体，都默认取第一个库存组织展示
            if (!this.schedulingOrderData?.orgNo || type === 'change') {
              this.$set(this.schedulingOrderData, 'orgNo', this.orgNoList[0]?.orgNo);
            }
          } else {
            if (type === 'change') { this.$set(this.schedulingOrderData, 'orgNo', ''); }
          }
        })
      } else {
        this.schedulingOrderData.orgNo = ''
      }
    },
    handleVendorCodeChange () {
      this.findOrg('change')
      this.schedulingOrderData.lineCode = ''
      this.$refs.refLineCodeSelector.handleSearch()
    }
  }
}
</script>

<style scoped lang="less">
.scheduling-order-form-container {
  padding: 0 10px;
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
}
</style>
